import React from "react";

export function isValidEmail(email: string): boolean {
  if (!email) return false;

  const value = email.trim();

  // 너무 긴 이메일 방지 (RFC 최대 길이 254)
  if (value.length > 254) return false;

  // 일반적인 이메일 검사용 정규식
  const emailRegex =
    /^(?=.{1,64}@.{1,255}$)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  // 연속 점 방지 (예: a..b@test.com)
  if (value.includes('..')) return false;

  return emailRegex.test(value);
}

export function selectFileByUser(e: React.ChangeEvent<HTMLInputElement>) {
  if (!e.target.files) return;
  return e.target.files[0];
}

export function removeExt(filename: string) {
  return filename.replace(/\.[^/.]+$/, "")
}
